/**
 * @desc 作废退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsMaterialRejectBillInvalidRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/invalid`, {
      method: "PUT",

      data: body,
      ...options,
    }),
  );
}
